export const quotes = [
  {
    content: '妈妈的朋友，像是岁月酿的一壶老酒，越陈越香，越品越有味道。',
    author: '— 读者 李晓华',
  },
  {
    content: '那些陪妈妈走过风风雨雨的阿姨们，是我见过最坚韧也最温柔的力量。',
    author: '— 读者 张美玲',
  },
  {
    content: '妈妈和她朋友们的笑声，是我童年里最温暖的背景音乐。',
    author: '— 读者 王芳',
  },
  {
    content: '岁月带走了青春，却带不走她们之间那份无需言语的默契。',
    author: '— 读者 陈丽',
  },
  {
    content: '在妈妈的朋友圈里，我看到了女性之间最纯粹的支持与陪伴。',
    author: '— 读者 刘静',
  },
  {
    content: '她们用半生时光，书写了一部关于友情的最美诗篇。',
    author: '— 读者 赵敏',
  },
  {
    content: '最懂妈妈的，永远是那些和她一起哭过笑过的老姐妹。',
    author: '— 读者 周婷',
  },
  {
    content: '妈妈的朋友圈不大，但每个人都是一本值得细细品读的书。',
    author: '— 读者 吴娟',
  },
];